module.exports = __webpack_public_path__ + "assets/img/34_868.3d10fb82.jpg";